import { Component, Input, HostBinding, HostListener } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { PopupService } from '../../services/popup.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[shared-delete-context]',
  templateUrl: 'delete-context.component.html',
  styleUrls: ['delete-context.component.scss'],
  standalone: false,
})
export class DeleteContextComponent {
  @Input() taskId: string;
  @Input() resourceId: string;

  @HostBinding('type')
  get type(): string {
    return 'button';
  }

  @HostBinding('class')
  get class(): string {
    return `btn btn-icon btn-cancel ${this.taskId != null ? ' m-r-auto' : ' m-l-auto'}`;
  }

  constructor(private apiService: ApiService, private popupService: PopupService) {}

  @HostListener('click')
  async onClick(): Promise<void> {
    if (await this.popupService.showDeleteQuestion('Reset context?', 'Doing this may affect orchestration. Please do this only on the direct advice of the Pointee support team.')) {
      if (this.taskId) {
        await this.apiService.scheduler.deleteTaskContext(this.taskId);
      } else if (this.resourceId) {
        await this.apiService.scheduler.deleteResourceContext(this.resourceId);
      }
      this.popupService.showSnackBar('Context reset successfully.');
    }
  }
}
